import React, { VFC } from 'react';
import { useTheme } from '@material-ui/core/styles';
import Styled from '../Styled';
import observeUserAuthChange from '../../../../core/firebase/observeUserAuthChange';

// TODO coreへの依存をなくす
import Notifications from '../../../../core/Notifications/Notifications';

const { IconWrapper, IconLink } = Styled;
const API_USER_CUSTOM_TOKEN = '/api/user/custom_token';

interface Props {}
const NotificationIconLink: VFC<Props> = (props: Props) => {
  const theme = useTheme();
  return (
    <IconWrapper theme={theme}>
      <IconLink>
        <Notifications
          col="users"
          observeUserAuthChange={observeUserAuthChange(API_USER_CUSTOM_TOKEN)}
          onUserChange={(user, setUid) => setUid(user.uid)}
        />
      </IconLink>
    </IconWrapper>
  );
};

export default NotificationIconLink;
